"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEdge = void 0;
// build a 'comparator' object for various comparison checks
var comparator = {
  '<': function _(a, b) {
    return a < b;
  },
  '<=': function _(a, b) {
    return a <= b;
  },
  '>': function _(a, b) {
    return a > b;
  },
  '>=': function _(a, b) {
    return a >= b;
  }
};

// helper function which compares a version to a range
var compareVersion = function compareVersion(version, range) {
  var string = range + '';
  var n = +(string.match(/\d+/) || NaN);
  var opArr = string.match(/^[<>]=?|/);
  var op = opArr !== null ? opArr[0] : '';
  return comparator[op] ? comparator[op](version, n) : Number(version) === n || Number.isNaN(n);
};
var isEdge = function isEdge(range) {
  if (typeof window === 'undefined') return false;
  var userAgent = (window.navigator && window.navigator.userAgent || '').toLowerCase();
  var match = userAgent.match(/edge\/(\d+)/);
  return match !== null && compareVersion(match[1], range);
};
exports.isEdge = isEdge;